import React, { useEffect, useState, useRef } from "react";
import classes from "./LandingContainer.module.css";

//components
import Navigation from "./Navigation/Navigation"; // the navigation buttons component

//libraries
import gsap from "gsap";

const LandingContainer = (props) => {
  const blur = useRef(null);
  const container = useRef(null);

  // these states manage the typing animation
  const [quote, setQuote] = useState("");
  const [cursor, setCursor] = useState("l");
  const [isCursorVisible, SetIsCursorVisible] = useState(false);

  useEffect(() => {
    // waits 1.9 settings before starting the typing animation (waits for the loading animation)
    gsap.from(container.current, {
      xPercent: -20,
      duration: 0.7,
      ease: "power2.easeOut",
      delay: 1,
    });
    gsap.from(blur.current, {
      xPercent: -40,
      duration: 1.2,
      ease: "power3.easeOut",
      delay: 1,
    });
    setTimeout(type, 1700);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // variables manage the typing animation
  var i = 0;
  var txt = "TURNING DISABLITY INTO ABILITY"; // quote to type
  var speed = 50; //speed in ms of typing (increase to slow the typing animation)

  //typing animation function
  const type = () => {
    //repeats until the whole message is typed
    if (i <= txt.length) {
      SetIsCursorVisible(true);
      setQuote(txt.substring(0, i));
      i++;
      setTimeout(type, speed);
    } else {
      // refreshes the cursor to appear and dissappear
      var j = 0;
      setInterval(() => {
        if (j > 10) {
          setCursor("");
          return;
        } else if (j % 2 === 0) {
          j++;
          setCursor("l");
        } else {
          j++;
          setCursor("");
        }
      }, 600);
    }
  };

  return (
    <div className={classes.container} ref={container}>
      {" "}
      {/* the container of the whole landing div */}
      {/* the diagonal white background */}
      <div className={classes.white}>
        {/* elements inside (this div is important to unskew and untranslate the elements) */}
        <div className={classes.elements}>
          {/* header (Logo and NavBar) */}
          <div className={classes.header}>
            {/* Logo */}
            {/* <img src={logo} alt="logo" className={classes.logo} /> */}
            {/* NavBar */}
            <Navigation />
          </div>
          {/* div that include the typing animation */}
          <div className={classes.body}>
            <div className={classes.quote}>
              {quote}
              <span className={classes.cursor}>
                {isCursorVisible && cursor}
              </span>
            </div>
          </div>
        </div>
      </div>
      {/* the blurry white background (it is behind the White background) */}
      <div className={classes.blur} ref={blur}></div>
    </div>
  );
};
export default LandingContainer;
